module.exports = __webpack_public_path__ + "fe7188fa3b14b0094d7f273acbb65423.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/images/steven-selfie.jpg
 ** module id = 394
 ** module chunks = 0
 **/